import SaveIcon from 'src/assets/images/icons/save-Icon.png';

export const SaveIconPNG = () => <img src={SaveIcon} alt="Save Icon" />;
